export default function SvgAkte() {
  return (
    <svg
      width="17"
      height="26"
      viewBox="0 0 17 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_50_371)">
        <path d="M17 0H0.0107422V1.78113H17V0Z" fill="white" />
        <path d="M1.73535 5.66553H0V5.68699H1.73535V5.66553Z" fill="white" />
        <path
          d="M16.9786 5.68689V3.90576H0V25.6978H6.82357V19.5175H9.98362V25.6978H17V5.68689H16.9786ZM15.2647 23.9167H11.5154V19.5175H11.5369V17.7364H5.28103V23.9167H1.73535V5.68689H15.2754V23.9167H15.2647Z"
          fill="white"
        />
        <path
          d="M16.9892 4.5708H16.9785V5.69742H16.9892V4.5708Z"
          fill="white"
        />
        <path
          d="M9.42636 9.00244H7.72314V14.2707H9.42636V9.00244Z"
          fill="#E11F26"
        />
        <path
          d="M10.98 10.7188H6.12744V12.5428H10.98V10.7188Z"
          fill="#E11F26"
        />
        <path
          d="M16.9892 3.90576H16.9785V5.68689H16.9892V3.90576Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_50_371">
          <rect width="17" height="25.6977" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
